import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "17",
  viewBox: "0 0 16 17",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M3.33317 4.65234L3.64632 14.6732C3.65757 15.0331 3.95258 15.319 4.31266 15.319H11.687C12.0471 15.319 12.3421 15.0331 12.3534 14.6732L12.6665 4.65234M3.33317 4.65234H12.6665M3.33317 4.65234H1.6665M12.6665 4.65234H14.3332M6.33317 7.98568V11.9857M9.6665 7.98568V11.9857M10.5825 4.65234C10.2865 3.50219 9.24241 2.65234 7.99985 2.65234C6.75729 2.65234 5.71322 3.50219 5.4172 4.65234",
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1)
  ])))
}
export default { render: render }